/**
 * Shared FX toggles surfaced in the debug panel (press P). Mutated by
 * main.ts when checkboxes change; read by game.ts / stage.ts at runtime.
 *
 * Defaults to ON for everything — these are the polish layer the play
 * was designed around.
 */
export const fxSettings = {
  typewriter: true,  // subtitle char-by-char reveal locked to voice duration
  spotlight: true,   // soft spotlight that tracks the current speaker
  idleSway: true,    // sprites breathe + sway slightly when not talking
  parallax: false,   // mouse-driven camera parallax across stage layers
  cloudPeekFullWidth: true,  // peek descents happen across full viewport width
                             // (off = peek only at parade-entry edges)
  showLabels: false,         // bake debug labels ("child", "rock", ...) onto sprites
  paperDust: true,           // ambient paper-fleck particles drifting across stage
  stageVignette: true,       // dark vignette inside the stage opening (3D-box feel)
  showMasks: false,          // mockup mask shelf at the back of the stage
  haze: true,                // atmospheric haze gradient between backdrop and cast
  globalHaze: true,          // gentle haze wash over the entire app (above UI)
  godRays: true,             // diagonal warm light shafts across the stage
  bgSoften: false,           // subtle blur + desaturation on the bg canvas (depth-of-field)
};

export type FxKey = keyof typeof fxSettings;
